<h1 mat-dialog-title class="paymentMethodTitle">Card or wallet payment</h1>
  <div mat-dialog-content>
    <div [style.display]="state === 'initial' ? 'block' : 'none'">
      <div>
        <div #paymentElement id="payment-element"></div>
      </div>

        <div id="card-errors" role="alert" style="display: flex; justify-content: center;">
            <strong> {{ stripeError }} </strong>
        </div>
    </div>

    <div [style.display]="state === 'loading' ? 'block' : 'none'">
        <div> Loading Stripe payment form... </div>
        <mat-spinner style="margin:0 auto;"></mat-spinner>
    </div>

    <div [style.display]="state === 'processing' ? 'block' : 'none'">
        <div> Processing your payment... {{ processing_message }}</div>
        <mat-spinner style="margin:0 auto;"></mat-spinner>
    </div>

    <div [style.display]="state === 'failure' ? 'block' : 'none'">
      <div> Error while working on: {{ processing_message }}</div>
      <div> {{ stripeError }} </div>
    </div>

    <div [style.display]="state === 'finished' ? 'block' : 'none'">
        <div> Your payment was successful and your products have been activated. </div>
    </div>

  </div>
    <div mat-dialog-actions style="justify-content: center;" *ngIf="state === 'loading'">
      <button mat-button (click)="close()"> Cancel </button>
    </div>
    <div mat-dialog-actions style="justify-content: space-between;" *ngIf="state === 'initial'">
      <button mat-button (click)="close()"> Cancel </button>
      <button mat-flat-button color="primary" (click)="submitPayment()">
        <span *ngIf="state === 'initial'"> Submit payment </span>
      </button>
    </div>
    <div mat-dialog-actions style="justify-content: center;" *ngIf="state === 'failure'">
      <button mat-button (click)="close()"> Close </button>
    </div>
    <div mat-dialog-actions style="justify-content: space-between;" *ngIf="state === 'finished'">
      <button mat-button (click)="close()"> Close </button>
      <button mat-flat-button color="primary" (click)="showReceipt()"> Show Receipt </button>
    </div>
